<template>
  <div id="search-form">
    <form action="" onsubmit="javascript:return false;" method="get">
      <input ref="searchInput" id="search-val" @keyup.enter="businessSearch" type="search" value="" name="searchKey" placeholder="输入搜索关键词">
      <button id="search-btn" @click="dosearch"><img class="not_wx_preview" :src="searchBtn"> </button>
    </form>
  </div>
</template>

<script>
  import searchBtn from '@/assets/search-btn.png'
  export default {
    name:'Search',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        searchBtn: searchBtn
      }
    },
    created() {
      // console.log('created search form'+this.$store.state.searchKey)
    },
    methods:{
      async dosearch(){
        let searchKey = document.getElementById('search-val').value
        if (!searchKey){
          window.location.reload()
        }
        this.$store.commit('setSearchKey', searchKey)
        // document.getElementById('search-val').value = ''
      },
      async businessSearch(){
        this.$refs.searchInput.blur()
      }
    }
  };
</script>
<style>
  input::-webkit-search-cancel-button{
    display: none;
  }
  input[type=search]::-ms-clear{
    display: none;
  }
  #search-form{
    margin:0 auto;
    /*text-align: center;*/
  }
  #search-form form{
    height:3.5rem;
    margin:0 0 0.5rem 0;
    /*line-height:2rem;*/
    /*padding:0 0.5rem;*/
    /*text-align: center;*/
  }
  #search-form form input{
    width: 90%;
    height: 3rem;
    line-height: 3rem;
    border-radius: 6rem;
    border: 1px solid #D8D8D8;
    font-size: 1rem;
    padding-left: 1rem;
    padding-right: 2rem;
    margin: 0.5rem 0;
    position: absolute;
    left: 5%;
    right: 5%;
    outline: none;
  }
  #search-form form button{
    height: 1.4rem;
    line-height: 1.4rem;
    margin: 0;
    border: 0;
    background-color: transparent;
    /* margin-left: -3rem; */
    position: absolute;
    right: 9%;
    top: 1.2rem;
    outline: none;
  }
  #search-form form button img{
    vertical-align: middle;
    width: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue